(ns frontend.ui.component.lp-portal.report.body.invest-europe.holding.exit.web.view
  (:require
   [common.util :as cu]
   [frontend.ui.component.grid.view :as grid]
   [frontend.ui.component.lp-portal.report.component.image.view :as image]
   [frontend.ui.component.lp-portal.report.component.overview-figures.view :as overview-figures]
   [frontend.ui.component.lp-portal.voima-components.chart-card.chart-card :as chart-card]
   [frontend.ui.component.lp-portal.voima-components.section.style :as style]
   [frontend.ui.component.lp-portal.voima-components.section.view :as section]
   [frontend.ui.component.lp-portal.report.body.invest-europe.holding.web.holding :refer [overview-card]]
   [frontend.ui.component.lp-portal.report.component.horizontal-table.view :as horizontal-table]
   [frontend.ui.component.lp-portal.voima-components.badge.view :as badge]
   [herb.core :refer [<class]]
   [frontend.ui.component.table.view :as table]))


(defn company-section
  [exit-ui-data props]
  (let [{:keys [overview highlight-figures-exit headcount-exit equity-grants-loans-exit financial-performance-exit
                logo-image-1 holding-name]}
        exit-ui-data]
    [section/portfolio-section
     [:div
      {:style {:display     :flex
               :justify-content :space-between
               :align-items :flex-end
               :gap         :16px}}
      [:div
       {:style {:display   :inline-flex
                :max-width :200px}}
       (when (and (not (:edit-mode? props)) (cu/blank-value? (:image logo-image-1)))
         [:div {:class (<class style/holding-header)} holding-name])
       [image/image (if (cu/blank-value? (:image logo-image-1)) "Add company logo" nil) logo-image-1 props true]]
      [:div
       {:style {:padding-top :16px}}
       [badge/badge
        {:variant :exited-investment
         :pill?   false}
        "Exited investment"]]]
     (str "company-section-"
          (some->> props
                   :report
                   :db/id))
     [:div {:class (<class style/section-wrapper)}
      [overview-card overview props]
      [:div
       {:style {:margin-top "8px"}}
       [overview-figures/overview-figures-card highlight-figures-exit props]]
      [grid/row {}
       [grid/column {:large 6}
        [chart-card/row-view "Headcount" headcount-exit (merge props {:border? true})]]
       [grid/column {:large 6}
        [chart-card/row-view "Financial performance" financial-performance-exit (merge props {:border? true})]]]
      [table/editable-table equity-grants-loans-exit props
       [horizontal-table/table "Equity, grants and loans" equity-grants-loans-exit props]]]]))

(defn exit
  [{:keys [holding-ui-data] :as props}]
  [:div {:id (str "holding-report-" (:report-id holding-ui-data))}
   [:div
    [company-section holding-ui-data props]]])
